import { withInstall } from '@jdesign-vue/utils'
import Tree from './src/tree.vue'

export const JdTree = withInstall(Tree)

export default JdTree
